module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"company":"Your contact person at"}}}}}}')
  delete Component.options._Ctor
}
